import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { FooterButtonStyled } from '~/styled';
import { SaveFeatureErrorProps } from './types';
import { SaveFeaturesError } from '@bechtel/types';

const getErrorMessage = (error: SaveFeatureErrorProps['saveFeatureError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case SaveFeaturesError.NOT_FOUND:
      return <Trans>Feature not found.</Trans>;
    case SaveFeaturesError.METADATA_DEFINITION_MISMATCH_ERROR:
      return <Trans>Meta data definition mismatch error.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const SaveFeatureErrorModal: FC<SaveFeatureErrorProps> = ({ saveFeatureError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="qty-config-error" style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Save Feature Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(saveFeatureError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default SaveFeatureErrorModal;
